import { dispatcher, Container, SpineBase, Linear, ITween, ingenuity, delayedCall, killDelayedCall, Bitmap } from "@quest/base-core";
import { IObject } from "@quest/adapter-interface";
import { SlotEventConstants } from "@quest/slot-core";
import { BitmapImage, Emitter } from "@quest/pixi-bridge";

import { MagicPotionFeatureView } from "./MagicPotionFeatureView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
export class MagicPotionFeatureController {
    private view: MagicPotionFeatureView;
    private magicPotionMainContainer: Container;
    private potionJackpotPositions: IObject[];
    private potionPointPositions: IObject[];
    private trailCounter: number = 0;
    private potHideCounter: number = 0;
    private jackpotWonWithMultiplier: IObject = {};
    private smoke: Bitmap;
    private smokeSprite: BitmapImage;
    private jackpotAwardedArray: string[] = [];
    private cloneMeterArray:any[]=[];
    private isTickupStarted: Boolean = false;
    private em: Emitter;
    private trailTween: ITween;
    private fadeTween: ITween;
    private trailParticleEmitter: Emitter;
    private gameCoinValue: number;
    private valueHundred: number = 100;
    private particleData: any = {
        
        emitterType: 0,
            id: "coinEmitter_1",
            autoStart: false,
            image: "White_bubble"
    };
    private particleConfig: any = {
        alpha: {
            start: 1,
            end: 0
        },
        scale: {
            start: 1.2,
            end: 0.3,
            minimumScaleMultiplier: 1
        },
        color: {
            start: "#ffffff",
            end: "#ffffff"
        },
        speed: {
            start: 50,
            end: 200,
            minimumSpeedMultiplier: 1
        },
        acceleration: {
            x: 0,
            y: 50
        },
        maxSpeed: 0,
        startRotation: {
            min: 0,
            max: 360
        },
        noRotation: false,
        rotationSpeed: {
            min: 0,
            max: 0
        },
        lifetime: {
            min: 1,
            max: 3
        },
        blendMode: "normal",
        frequency: 0.03,
        emitterLifetime: -1,
        maxParticles: 80,
        pos: {
            x: 0,
            y: 0
        },
        addAtBack: false,
        spawnType: "circle",
        spawnCircle: {
            x: 0,
            y: 0,
            r: 0
        }
    };
    private minorPot: string = "white_pot_to_blue";
    private grandPot: string = "white_pot_to_red";
    private miniPot: string = "white_pot_to_green";
    private majorPot: string = "white_pot_to_purple";

    constructor(view: MagicPotionFeatureView) {
        this.view = view;
        this.view.visible = true;
        this.initializeElements();
        this.subscribeEvent();
    }

    /**
   * Initialize Elements
   */
    private initializeElements(): void {
        this.magicPotionMainContainer = this.view.getContainerByID("magicPotionMainContainer");
        this.smoke = this.view.getImageById("miniParticle");
    }

    /**
  * Method to subscribeEvents.
  */
    private subscribeEvent(): void {
        this.unSubscribeEvent();
        dispatcher.on(eventDispatchers.MAGIC_POTION_START, this.magicPotionConversion, this);
        dispatcher.on(eventDispatchers.MAGIC_POTION_JACKPOT_CONVERSION, this.potToJackpotConversion, this);
        dispatcher.on(eventDispatchers.FS_POT_SYMBOL_CONVERSION, this.fsPotSymbolConversion, this);
        dispatcher.on(eventDispatchers.HIDE_MAGIC_POTION, this.hideMagicPotionView, this);
        dispatcher.on(eventDispatchers.SHOW_MAGIC_POTION, this.showMagicPotionView, this);
        dispatcher.on(eventDispatchers.RESET_DATA, this.clearData, this);
        dispatcher.on(eventDispatchers.FORCE_STOP_POT_CONVERSION, this.forceStopPotConversion, this);
    }

    /**
  * Method to unSubscribeEvent.
  */
    private unSubscribeEvent(): void {
        dispatcher.off(eventDispatchers.MAGIC_POTION_START, this.magicPotionConversion, this);
        dispatcher.off(eventDispatchers.MAGIC_POTION_JACKPOT_CONVERSION, this.potToJackpotConversion, this);
        dispatcher.off(eventDispatchers.FS_POT_SYMBOL_CONVERSION, this.fsPotSymbolConversion, this);
        dispatcher.off(eventDispatchers.HIDE_MAGIC_POTION, this.hideMagicPotionView, this);
        dispatcher.off(eventDispatchers.SHOW_MAGIC_POTION, this.showMagicPotionView, this);
        dispatcher.off(eventDispatchers.RESET_DATA, this.clearData, this);
        dispatcher.off(eventDispatchers.FORCE_STOP_POT_CONVERSION, this.forceStopPotConversion, this);
    }

    /**
   * Method playTrailAnimation to play trail animation
   */
    protected playTrailAnimation(index: number): void {
        this.smoke = this.view.getImageById(this.jackpotAwardedArray[this.trailCounter] + "Particle");
        const potOffsetArray: number[][] = (ingenuity.parserModel as GameParserModel).getMotionPotOffsets();
        this.createTrailImage(potOffsetArray[this.trailCounter][0], potOffsetArray[this.trailCounter][1]);
        this.createTrailEmitter();
        this.playMultiplierTrailAnim(index);
    }

    /**
       * This method is use to create trail image
       */
    private createTrailImage(colNum: number, rowNum: number): void {
        this.smokeSprite = new BitmapImage(ingenuity.currentGame, 0, 0, "smoke_puff");
        this.smokeSprite.x = this.view.json.smokeSpriteXY[colNum][rowNum][0];
        this.smokeSprite.y = this.view.json.smokeSpriteXY[colNum][rowNum][1];
        this.particleData.id = this.view.json.smokeSprite.id;
        this.smokeSprite.name = this.view.json.smokeSprite.name;
        this.smokeSprite.alpha = this.view.json.smokeSprite.alpha;
        this.smokeSprite.scale.set(this.view.json.smokeSprite.scale);
        this.smokeSprite.anchor.set(this.view.json.smokeSprite.anchorX, this.view.json.smokeSprite.anchorY);
        this.smoke.parent.addChild(this.smokeSprite);
    }

    /**
       * This method create emitter for trail
       */
    private createTrailEmitter(): void {
        this.trailParticleEmitter = ingenuity.currentGame.add.emitter(this.view.getContainerByID(this.jackpotAwardedArray[this.trailCounter] + "TrailAnimationContainer"), this.particleData, this.particleConfig) as Emitter;
        this.trailParticleEmitter.autoUpdate = true;
        this.trailParticleEmitter.emit = true;
        this.trailParticleEmitter.updateOwnerPos(this.smokeSprite.x, this.smokeSprite.y);
    }

    /**
    * This method is use to play the trail tween
     */
    private playMultiplierTrailAnim(index: number): void {
        (ingenuity.soundManager as any).play(SoundConstantGame.SPECIAL_VALUE_PARTICLE_FLY, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        let trailConfigs: IObject = this.view.json.smokeSprite;
        let points: number[][] = this.addSineWave(this.smokeSprite.x, this.smokeSprite.y, trailConfigs.finalX, trailConfigs.finalY, trailConfigs.amplitude, trailConfigs.frequency, trailConfigs.numPoints);
        this.trailTween = ingenuity.currentGame.add.tween(this.smokeSprite).to({ x: points[0], y: points[1] }, 500, undefined, true);
        this.trailTween.onComplete.addOnce(() => {
            (ingenuity.soundManager as any).play(SoundConstantGame.SPECIAL_VALUE_PARTICLE_LAND, 1, false, gameConstants.SOUND_LIST_PRELOAD);

            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(this.trailTween.target.name);
            em.autoUpdate = false;
            em.emit = false;
            em.destroy();

            this.trailTween.stop();
            this.trailTween.onUpdateCallback = null;
            ingenuity.currentGame.tweens.remove(this.trailTween);
            this.trailTween.target.parent.removeChild(this.trailTween.target);
            //Play Blasted Bubbles
            dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_WINBLAST);
            this.trailCounter += 1;
            //Start the win tickup when pot symbol lands
            if (!this.isTickupStarted) {
                this.isTickupStarted = true;
                dispatcher.fireEvent(eventDispatchers.START_POT_WIN_TICKUP);
            }

        }, this);

        this.trailTween.onUpdateCallback((evt: IObject) => {
            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
            em.updateOwnerPos(evt.target.x, evt.target.y);
        });
    }

    /**
     * This method will return a 2D array of [x,y] coordinates to create wave pattern in trail tween  
     */
    private addSineWave(startX: number, startY: number, endX: number, endY: number, amplitude: number, frequency: number, numPoints: number): number[][] {
        // Calculate the change in X and Y per point
        const deltaX: number = (endX - startX) / (numPoints - 1);
        const deltaY: number = (endY - startY) / (numPoints - 1);

        // Arrays to store X and Y coordinates
        const xCoords: number[] = [];
        const yCoords: number[] = [];

        // Generate points along the line and add sine wave to Y coordinates
        for (let i = 0; i < numPoints; i++) {
            // Calculate current X coordinate
            const x: number = startX + i * deltaX;
            // Calculate Y coordinate with added sine wave
            const y: number = startY + i * deltaY + amplitude * Math.sin(2 * Math.PI * frequency * (x - startX) / (endX - startX));
            // Store X and Y coordinates
            xCoords.push(x);
            yCoords.push(y);
        }

        // Return X and Y coordinates as separate arrays
        return [xCoords, yCoords];
    }

    /**
     * Method magicPotionConversion to start white pot conversion
     */
    private magicPotionConversion(): void {
        this.gameCoinValue = (ingenuity.parserModel as GameParserModel).getTotalBet() / (ingenuity.parserModel as GameParserModel).getLinesPlayed();
        this.isTickupStarted = false;
        this.resetTrailConfigs();
        this.potionJackpotPositions = (ingenuity.parserModel as GameParserModel).getPotionJackpotPositionsBG();
        this.potionPointPositions = (ingenuity.parserModel as GameParserModel).getPotionPointPositionsBG();

        this.checForJackpotPrize();
    }

    /**
     * Method checForJackpotPrize to check for prize on pots
     */
    private checForJackpotPrize(): void {
        const startIndex: number = 0;
        this.potionJackpotPositions.forEach((element, index) => {
            let gridNumber = Number(Object.keys(element));
            let jackpotValue = Object.values(element)[0];
            this.addJackpotAnimOnLayer(jackpotValue, gridNumber);

        });
        this.startPrizeSymbolConversionAnim(startIndex);
    }

    /**
     * Method startPrizeSymbolConversionAnim to start pot conversion with prize and color
     */
    private startPrizeSymbolConversionAnim(index: number): void {
        if (index >= this.magicPotionMainContainer.children.length) {
            return;
        }
        const magicPotContainer: Container = this.magicPotionMainContainer.children[index];
        if (magicPotContainer.children.length != 0 && !ingenuity.configData.isForceStopDuringPot) {
            const conversionAnim: SpineBase = magicPotContainer.children[0];
            this.storeAwardedJackpot(conversionAnim);
            (ingenuity.soundManager as any).play(SoundConstantGame.PRIZE_VALUE, 1, false, gameConstants.SOUND_LIST_PRELOAD);
            conversionAnim.visible = true;
            conversionAnim.playAnim("animation");
            conversionAnim.onComplete.addOnce(() => {
                conversionAnim.playAnim("loop_without_text", true);
            });
            this.getjackpotPrizeValue(magicPotContainer, index)
        }
        else {
            this.startPrizeSymbolConversionAnim(index + 1);
        }
    }

    /**
     * Method getjackpotPrizeValue to get and show prize value on pots
     */
    private getjackpotPrizeValue(magicPotContainer: Container, index: number): void {
        //Hide pot landing animation when pot conversion animation 
        const potOffsetArray: number[][] = (ingenuity.parserModel as GameParserModel).getMotionPotOffsets();
        dispatcher.fireEvent(eventDispatchers.HIDE_POTION_LANDING_SYMBOL, [potOffsetArray[this.potHideCounter][0], potOffsetArray[this.potHideCounter][1]]);

        //for jackpot prize
        const gridNumber = Number(magicPotContainer.json.id.split("_")[2]);
        const jackpotPrizeData = this.potionPointPositions.find(obj => Object.keys(obj).includes(gridNumber.toString()));

        const potPrizeValue: number = jackpotPrizeData[`${gridNumber}`];
        const jackpotPrize: number = Math.round(potPrizeValue * this.gameCoinValue * this.valueHundred);
        this.showPrizeValueOnPot(jackpotPrize, magicPotContainer, index);

        //Increase the static pot hide counter
        this.potHideCounter += 1;
    }

    /**
     * Method storeAwardedJackpot to store awarded jackpots
     */
    private storeAwardedJackpot(currentSpine: SpineBase): void {
        let currentColor: string = currentSpine.name.slice(13);
        if (currentColor === "blue") {
            this.jackpotAwardedArray.push("minor");
        } else if (currentColor === "red") {
            this.jackpotAwardedArray.push("grand");
        } else if (currentColor === "green") {
            this.jackpotAwardedArray.push("mini");
        } else if (currentColor === "purple") {
            this.jackpotAwardedArray.push("major");
        }
    }


    /**
  * Method to add jackpot spine in container
  */
    private addJackpotAnimOnLayer(jackpotValue: string, gridNumber: number): void {
        this.magicPotionMainContainer.visible = true;
        const container = this.view.getContainerByID(`magicPotion_Container_${gridNumber}`);
        container.visible = true;

        if (jackpotValue === "mini") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.miniPot);
            container.addChild(clonedSpine);
        }
        else if (jackpotValue === "minor") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.minorPot);
            container.addChild(clonedSpine);
        }
        else if (jackpotValue === "major") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.majorPot);
            container.addChild(clonedSpine);
        }
        else if (jackpotValue === "grand") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.grandPot);
            container.addChild(clonedSpine);
        }

    }

    /**
  * Method to show prize value on Pot symbol with tween
  */
    private showPrizeValueOnPot(jackpotPrize: number, container: Container, index: number): void {
        const nextPotConversionDelay: number = 200;
        const cloneMeter = this.view.getCloneWinValueMeter();
        const jpPrize=Math.round(jackpotPrize);
        cloneMeter.setText(jpPrize.toString());
        cloneMeter.visible = true;
        container.addChild(cloneMeter);
        cloneMeter.alpha = 0;
        cloneMeter.x += 1;
        cloneMeter.y += 1;
        this.cloneMeterArray.push(cloneMeter);
        this.fadeTween = ingenuity.currentGame.add.tween(cloneMeter).to({ alpha: 1 }, 1200, Linear.None, true, 0, 0, false);
        this.fadeTween.onComplete.addOnce(() => {
            ingenuity.currentGame.tweens.remove(this.fadeTween);
            delayedCall('symbolConversion', nextPotConversionDelay, () => {
                killDelayedCall('symbolConversion');
                this.startPrizeSymbolConversionAnim(index + 1);
            });
            !ingenuity.configData.isForceStopDuringPot && this.playTrailAnimation(index);
        }, this);
    }

    /**
  * Method to convert pot into jackpot pots
  */
    private potToJackpotConversion(): void {
        this.jackpotWonWithMultiplier = (ingenuity.parserModel as GameParserModel).getJackpotWonBG();
        (ingenuity.soundManager as any).play(SoundConstantGame.JACKPOT_CONVERT, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        for (const key in this.jackpotWonWithMultiplier) {
            if (this.jackpotWonWithMultiplier.hasOwnProperty(key)) {
                for (const jackpotItem of this.potionJackpotPositions) {
                    const itemKey = Number(Object.keys(jackpotItem)[0]);
                    const itemValue = jackpotItem[itemKey];
                    if (itemValue === key) {
                        this.addJackpotPotionsToLayer(itemValue, itemKey);
                    }
                }
            }
        }
        delayedCall(gameConstants.SEND_SHOW_NEXT_WIN_PRESENTATION_REQUEST, gameConstants.TIME_OUT_JP_CONVERSION, () => {
            killDelayedCall(gameConstants.SEND_SHOW_NEXT_WIN_PRESENTATION_REQUEST);
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        });

    }

    /**
 * Method forceStopPotConversion to show all pot prizes at a time
 */
    private forceStopPotConversion(): void {
        ingenuity.configData.isForceStopDuringPot = true;
        ingenuity.currentGame.tweens.remove(this.fadeTween);
        this.cloneMeterArray.forEach((meter:any)=>{
            meter.alpha = 1;
        });
        killDelayedCall('symbolConversion');
        // Hide pot landing animation when pot conversion animation 
        const potOffsetArray: number[][] = (ingenuity.parserModel as GameParserModel).getMotionPotOffsets();
        for (const jackpotItem of this.potionJackpotPositions) {
            for (let i = 0; i < this.potionPointPositions.length; i++) {
                let potionPoint: IObject = this.potionPointPositions[i];
                dispatcher.fireEvent(eventDispatchers.HIDE_POTION_LANDING_SYMBOL, [potOffsetArray[i][0], potOffsetArray[i][1]]);
                const itemKey = Number(Object.keys(jackpotItem)[0]);
                const itemValue = jackpotItem[itemKey];
                //play pot symbol anim
                this.playPotAnimOnStageClick(itemValue, itemKey);
                const prizeID: number = Number(Object.keys(potionPoint)[0]);
                const prizeValue: number = potionPoint[prizeID] * this.gameCoinValue * this.valueHundred;
                if (itemKey === prizeID && itemValue != "fs") {
                    //show prize on pot symbol
                    this.showPrizeValueOnPotOnStageClick(prizeValue, prizeID);
                }
            }
        }
        this.stopTrailParticle();
    }

    /**
     * Method stopPotPresentation to stop trail on stage click
     */
    private stopTrailParticle(): void {
        if (this.trailTween) {
            this.trailTween.stop();
            ingenuity.currentGame.tweens.remove(this.trailTween);
        }
        if (this.trailParticleEmitter) {
            this.trailParticleEmitter.destroy();
            this.trailParticleEmitter.emit = false;
        }
        //stop win tickup forcefully
        dispatcher.fireEvent(eventDispatchers.FORCE_STOP_POT_WIN_METER_TICKUP);
    }

    /**
     * Method playPotAnimOnStageClick to play pot conversion animation during stage click
     */
    private playPotAnimOnStageClick(jackpotValue: string, gridNumber: number): void {
        this.magicPotionMainContainer.visible = true;
        const container = this.view.getContainerByID(`magicPotion_Container_${gridNumber}`);
        container.visible = true;
        if (!container.children[0]) {
            if (jackpotValue === "mini") {
                const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.miniPot);
                this.playSpineOnStageClick(container, clonedSpine);
            }
            else if (jackpotValue === "minor") {
                const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.minorPot);
                this.playSpineOnStageClick(container, clonedSpine);
            }
            else if (jackpotValue === "major") {
                const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.majorPot);
                this.playSpineOnStageClick(container, clonedSpine);
            }
            else if (jackpotValue === "grand") {
                const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.grandPot);
                this.playSpineOnStageClick(container, clonedSpine);
            }
        } else if (container.children.length === 1) {
            this.playAlreadyAddedPotSpine(container.children[0]);
        }
    }

    /**
     * Method playAlreadyAddedPotSpine to play pot animation which are already played before stage click
     */
    private playAlreadyAddedPotSpine(potSpine: SpineBase): void {
        potSpine.visible = true;
        potSpine.playAnim("animation");
        potSpine.onComplete.addOnce(() => {
            potSpine.playAnim("loop_without_text", true);
        });
    }

    /**
  * Method showPrizeValueOnPotOnStageClick to show prize on all pots during stage click
  */
    private showPrizeValueOnPotOnStageClick(jackpotPrize: number, index: number): void {
        this.magicPotionMainContainer.visible = true;
        const container = this.view.getContainerByID(`magicPotion_Container_${index}`);
        if (!container.children[1]) {
            container.visible = true;
            const cloneMeter = this.view.getCloneWinValueMeter();
            const jpPrize=Math.round(jackpotPrize);
            cloneMeter.setText(jpPrize.toString());
            cloneMeter.visible = true;
            container.addChild(cloneMeter);
            cloneMeter.alpha = 0;
            cloneMeter.x += 1;
            cloneMeter.y += 1;
            const fadeEffect: ITween = ingenuity.currentGame.add.tween(cloneMeter).to({ alpha: 1 }, 1200, Linear.None, true, 0, 0, false);
            fadeEffect.onComplete.addOnce(() => {
                ingenuity.currentGame.tweens.remove(fadeEffect);
            }, this);
        }
    }

    /**
 * Method playSpineOnStageClick play animation
 */
    private playSpineOnStageClick(container: Container, conversionAnim: SpineBase): void {
        container.addChild(conversionAnim);
        conversionAnim.visible = true;
        conversionAnim.playAnim("animation");
        conversionAnim.onComplete.addOnce(() => {
            conversionAnim.playAnim("loop_without_text", true);
        });
    }

    /**
  * Method to add jackpot potions
  */
    private addJackpotPotionsToLayer(jackpotValue: string, gridNumber: number): void {
        const container = this.view.getContainerByID(`magicPotion_Container_${gridNumber}`);
        if (jackpotValue === "mini") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.miniPot);
            this.playSpineAnim(clonedSpine, container);

        }
        else if (jackpotValue === "minor") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.minorPot);
            this.playSpineAnim(clonedSpine, container);

        }
        else if (jackpotValue === "major") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.majorPot);
            this.playSpineAnim(clonedSpine, container);

        }
        else if (jackpotValue === "grand") {
            const clonedSpine: SpineBase = this.view.getSpineJsonAndClone(this.grandPot);
            this.playSpineAnim(clonedSpine, container);
        }
    }

    /**
   * Method to play jackpot potions animation
   */
    private playSpineAnim(spine: SpineBase, container: Container): void {
        container.addChild(spine);
        spine.visible = true;
        container.children[0].visible = false;
        container.children[1].visible = false;
        spine.playAnim("pot_to_jackpot", false);
        spine.onComplete.addOnce(() => {
            spine.playAnim("pot_to_jackpot_loop", true);
        })
    }

    /**
     * Method to convert pot to FS
     */
    private fsPotSymbolConversion(): void {
        this.potionJackpotPositions.forEach((element, index) => {
            let gridNumber = Number(Object.keys(element));
            let jackpotValue = Object.values(element)[0];
            this.checkForFsSymbol(jackpotValue, gridNumber);
        });
    }

    /**
     * Method to check FS pot symbol
     */
    private checkForFsSymbol(jackpotValueFs: string, gridNumber: number): void {
        if (jackpotValueFs === gameConstants.FS_SYMBOL_SC) {
            for (let i = 0; i < this.potionJackpotPositions.length; i++) {
                const values = this.potionJackpotPositions[i];
                const jackpotKey = Number(Object.keys(values)[0]);
                const jackpotValue = values[jackpotKey];
                if (gridNumber === jackpotKey && jackpotValue != gameConstants.FS_SYMBOL_SC) {
                    this.playFSSymbolConversion(jackpotValue, jackpotKey);
                }
            }

        }
    }

    /**
    * Method to check for jackpot + FS symbol
    */
    private playFSSymbolConversion(jackpotValue: string, jackpotKey: number): void {
        (ingenuity.soundManager as any).play(SoundConstantGame.FS_SPECIAL_ICON, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        this.magicPotionMainContainer.visible = true;
        const container = this.view.getContainerByID(`magicPotion_Container_${jackpotKey}`);
        if (jackpotValue === "mini") {
            const green_pot_freespin: SpineBase = this.view.getSpineJsonAndClone(this.miniPot);
            this.playFSSymbolAnim(green_pot_freespin, container)
        }
        else if (jackpotValue === "minor") {
            const blue_pot_freespin: SpineBase = this.view.getSpineJsonAndClone(this.minorPot);
            this.playFSSymbolAnim(blue_pot_freespin, container)
        }
        else if (jackpotValue === "major") {
            const purple_pot_freespin: SpineBase = this.view.getSpineJsonAndClone(this.majorPot);
            this.playFSSymbolAnim(purple_pot_freespin, container)
        }
        else if (jackpotValue === "grand") {
            const red_pot_freespin: SpineBase = this.view.getSpineJsonAndClone(this.grandPot);
            this.playFSSymbolAnim(red_pot_freespin, container)
        }
    }

    /**
    * Method to play FS symbol animation
    */
    private playFSSymbolAnim(spine: SpineBase, container: Container): void {
        if (container.children[2]) {
            //Hide jackpot symbol when triggered from jackpot
            container.children[2].visible = false;
        } else {
            //Hide pot & prize when triggered from pot prize
            container.children[0].visible = false;
            container.children[1].visible = false;
        }
        spine.visible = true;
        container.addChild(spine);
        spine.playAnim("free_spin", false);
        spine.onComplete.addOnce(() => {
            spine.playAnim("free_spin_loop", true);
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        })
    }

    /**
     * Method to reset data
     */
    private clearData(): void {
        this.cloneMeterArray = [];
        this.magicPotionMainContainer.visible = false;
        (ingenuity.parserModel as GameParserModel).setIsMagicPotionBG(false);
        (ingenuity.parserModel as GameParserModel).setIsJackpotWonBG(false);
        (ingenuity.parserModel as GameParserModel).setIsFSPotPresentBG(false);
        (ingenuity.parserModel as GameParserModel).setPotionJackpotPositionsBG([]);
        this.potionJackpotPositions = [];
        this.jackpotWonWithMultiplier = {};

        for (let i = 0; i < this.magicPotionMainContainer.children.length; i++) {
            for (let j = this.magicPotionMainContainer.children[i].length - 1; j >= 0; j--) {
                this.magicPotionMainContainer.children[i].children[j].destroy();
            }
        }
    }

    /**
     * Hide Magic Potion View
     */
    private hideMagicPotionView(): void {
        this.view.visible = false;
    }

    /**
     * Show Magic Potion View
     */
    private showMagicPotionView(): void {
        this.view.visible = true;
    }

    /**
     * Reset animation configurations
     */
    private resetTrailConfigs(): void {
        this.trailCounter = 0;
        this.potHideCounter = 0;
        this.jackpotAwardedArray = [];
        this.view.getContainerByID("coinShowerContainer").removeChildren();
        if (this.em) {
            this.em.emit = false;
            this.em.destroy();
        }
    }

}